import { render, staticRenderFns } from "./Tracking.vue?vue&type=template&id=4478472c&lang=pug&"
import script from "./Tracking.vue?vue&type=script&lang=ts&"
export * from "./Tracking.vue?vue&type=script&lang=ts&"
import style0 from "./Tracking.vue?vue&type=style&index=0&id=4478472c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports